import {} from "antd";
import { SHORTCUTS, ShortcutDescriptor } from "../../Constant";
import { drawerTitle } from "../AppUi";
import { useIsMobile, useIsTablet } from "../../Hook";
import { ResizableDrawer } from "../ResizableDrawer/ResizableDrawer";

export const ShortKeyPanel = ({
  shortkeysOpen,
  setShortkeysOpen,
}: {
  shortkeysOpen: boolean;
  setShortkeysOpen: (open: boolean) => void;
}) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return (
    <ResizableDrawer
      title={drawerTitle(
        "POS Keyboard Shortcuts Guide",
        "Quick key bindings for faster checkout operations",
      )}
      placement="left"
      onClose={() => setShortkeysOpen(false)}
      open={shortkeysOpen}
      width={isMobile || isTablet ? "100%" : 400}
    >
      <div className="flex flex-col gap-6 font-sans">
        {Object.entries(SHORTCUTS).map(([sectionKey, shortcutsGroup]) => {
          const items = Object.values(shortcutsGroup) as ShortcutDescriptor[];

          return (
            <div key={sectionKey} className="flex flex-col gap-2.5">
              <h4
                className={`text-[11px] font-bold uppercase tracking-wider border-b pb-1`}
              >
                {sectionKey} Actions
              </h4>
              <div className="flex flex-col gap-2">
                {items.map((item, idx) => (
                  <div
                    key={item.id || idx}
                    className="flex justify-between items-center text-xs"
                  >
                    <span className="text-gray-600">{item.description}</span>
                    <div className="flex gap-1">
                      {item.name.split("+").map((k, kIdx) => (
                        <kbd
                          key={kIdx}
                          className={`px-1.5 py-0.5 border border-gray-200 rounded text-gray-700 font-mono text-[10px] shadow-sm`}
                        >
                          {k}
                        </kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </ResizableDrawer>
  );
};
